export default function convertStringOrNumberToStringBoolean(
  value: string | number
): string {
  const valueToNumber = Number(value)
  return valueToNumber ? 'Sim' : 'Não'
}
